/**
 * Swaps the tab icon between Anima's and Agent Grid's.
 *
 * Flows started from Agent Grid render Agent Grid branding (see src/utils/authBrand.js),
 * so the tab should not keep showing Anima's mark. The links declared in public/index.html
 * are replaced at runtime because the two brands share one build.
 */

import { isAgentGridSource } from '@/utils/authBrand';

const ICON_LINK_SELECTOR = 'link[rel="icon"], link[rel="shortcut icon"], link[rel="apple-touch-icon"]';

const ANIMA_ICONS = [
  { rel: 'icon', href: 'favicon.png' },
  { rel: 'apple-touch-icon', href: 'apple-touch.png' }
];

const AGENT_GRID_ICONS = [
  { rel: 'icon', sizes: '16x16', href: 'agentgrid-favicon-16.png' },
  { rel: 'icon', sizes: '32x32', href: 'agentgrid-favicon-32.png' },
  { rel: 'icon', sizes: '64x64', href: 'agentgrid-favicon-64.png' },
  { rel: 'apple-touch-icon', href: 'agentgrid-favicon-120.png' }
];

// The brand currently in the document. Navigations that don't change it leave the links
// alone — re-inserting them makes the browser re-fetch the icons and flicker the tab.
let appliedBrand = null;

const iconUrl = (fileName) => `${process.env.BASE_URL || '/'}${fileName}`;

export const applyBrandFavicon = (query) => {
  if (typeof document === 'undefined') {
    return;
  }

  const brand = isAgentGridSource(query) ? 'agentgrid' : 'anima';
  if (brand === appliedBrand) {
    return;
  }

  const isFirstApply = appliedBrand === null;
  appliedBrand = brand;

  // index.html already ships Anima's icons, so the usual Anima page load needs no DOM work.
  if (isFirstApply && brand === 'anima') {
    return;
  }

  document.head.querySelectorAll(ICON_LINK_SELECTOR).forEach((link) => link.remove());

  const icons = brand === 'agentgrid' ? AGENT_GRID_ICONS : ANIMA_ICONS;
  icons.forEach(({ rel, sizes, href }) => {
    const link = document.createElement('link');
    link.rel = rel;
    if (sizes) {
      link.sizes = sizes;
    }
    link.href = iconUrl(href);
    document.head.appendChild(link);
  });
};
